<template>
  <div class="recording-container" :class="isRecording && 'recording-size'">
    <div class="recording" v-if="isRecording">
      <hcc-button-icon @click="stopRecorder" class="recording__button">
        <close-icon class="recording__button-cancel" />
      </hcc-button-icon>
      <div class="recording__timeslot">
        <dot-icon class="recording__icon blinking" />
        <div class="recording__time">
          {{ recordedTime }}
        </div>
      </div>
      <hcc-button-icon @click="toggleRecorder(false)" class="recording__button">
        <check-single-icon class="recording__button-accept" />
      </hcc-button-icon>
    </div>
    <template v-else>
      <input-button @clicked="toggleRecorder(true)" :disabled="disabled">
        <microphone-icon class="input__icon" />
      </input-button>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import HccButtonIcon from '@/components/shared/HccButtonIcon/index.vue';
import DotIcon from '@/assets/icons/dot.svg';
import Recorder from '../utils/recorder';

export default {
  components: {
    InputButton: () => import('@/components/InputButton.vue'),
    CloseIcon: () => import('@/assets/icons/close.svg'),
    CheckSingleIcon: () => import('@/assets/icons/check-single.svg'),
    MicrophoneIcon: () => import('@/assets/icons/microphone.svg'),
    HccButtonIcon,
    DotIcon,
  },
  props: {
    disabled: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      recorder: this.initRecorder(),
      isRecording: false,
      format: 'mp3',
    };
  },
  computed: {
    ...mapGetters([
      'userInfo',
    ]),
    recordedTime() {
      return new Date(this.recorder.duration * 1000).toISOString().substr(14, 5);
    },
  },
  methods: {
    reset() {
      this.recorder = this.initRecorder();
      this.isRecording = false;
      this.format = 'mp3';
    },
    initRecorder() {
      this.isRecording = false;

      return new Recorder({
        beforeRecording: null,
        afterRecording: null,
        pauseRecording: null,
        micFailed: this.micFailed,
      });
    },
    micFailed() {
      this.isRecording = false;
      this.recorder = this.initRecorder();
    },
    toggleRecorder(recording) {
      this.isRecording = recording;

      if (!this.recorder.isRecording) {
        setTimeout(() => this.recorder.start(), 200);
      } else {
        try {
          this.recorder.stop();
          const record = this.recorder.records[0];
          // can send duration
          // const duration = record.duration;
          const name = `voice-${this.uuidv4()}.${this.format}`;
          const data = {
            tempId: this.uuidv4(),
            text: null,
            type: 'audio',
            typeUser: 'User',
            user: this.userInfo,
            multimedia: new File([record.blob], name, record.blob),
          };
          this.sendMessage(data);
        } catch {
          setTimeout(() => this.stopRecorder(), 100);
        }
      }
    },
    stopRecorder() {
      if (this.recorder.isRecording) {
        try {
          this.recorder.stop();
          this.recorder = this.initRecorder();
        } catch {
          setTimeout(() => this.stopRecorder(), 100);
        }
      }
    },
    sendMessage(msg) {
      this.$emit('send-message-audio', msg);
      this.reset();
    },
  },
};
</script>

<style scoped lang="scss">
@import "~styles/components/chat-input-audio.scss";
</style>
